<template>
  <div class="open-time">
    <h1 class="m-font-1 mb-50 ml-36">展区导引</h1>
    <div class="content">
      <div class="left">
        <div class="left-inner">
          <img :class="{'floor2':chooseId == 1}" :src="defaultBg" alt="">
        </div>
        <div class="floor-wrapper">
          <span v-for="(item, index) in floorList" :key="index" :class="{'active':index==chooseId}"
            @click="changeFloor(item, index)">{{ item.name }}</span>
        </div>
      </div>
      <div class="right">
        <h1 class="title">{{chooseId == 0 ? '一楼' : chooseId == 1 ? '二楼': '三楼'}}<span
            style="margin-left: 40px;">正在展出</span></h1>
        <ul class="list-wrapper">
          <li class="list-item" v-for="(item, index) in exhibitionList" @click="goDetail(item)" :key="index">
            <div class="img-wrapper">
              <img :src="item.mainPic" :onerror="defaultImg" alt="">
            </div>
            <div class="right-content">
              <p class="name two-ell">{{item.name || ''}}</p>

              <div class="flex-box">
                <p class="address ell">{{item.address}}</p>
                <p class="ty">{{item.type || ''}}</p>
              </div>

            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      dataList: [],
      chooseId: 0,
      defaultBg: require('../../assets/images/map_1f@2x.png'),
      floorList: [{ id: 1, name: '1F', img: require('../../assets/images/map_1f@2x.png') }, { id: 2, name: '2F', img: require('../../assets/images/map_2f@2x.png') }, { id: 3, name: '3F', img: require('../../assets/images/map_3f@2x.png') }],
      exhibitionList: []
    };
  },

  mounted() {
    this.getData(1)
  },

  methods: {
    getData(id) {
      this.$http
        .get('../singleMuseum/webapi/zqdy', { id: id })
        .then(res => {
          if (res.success) {
            this.dataList = res.result
            if (res.result && res.result.length > 0) {
              this.exhibitionList = res.result
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    changeFloor(obj, dx) {
      this.defaultBg = obj.img
      this.chooseId = dx
      this.getData(obj.id)
    },

    goDetail(item) {
      this.$router.push({
        path: '/exhibition/detail',
        query: { id: item.id }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.open-time {
  width: 100%;

  .content {
    display: flex;
    flex-direction: column;
    margin: 0 36px;
    .left {
      width: 100%;
      margin-bottom: 40px;
      .left-inner {
        height: 488px;
        box-sizing: border-box;
        background: #f6f6f6;
        text-align: center;
        padding: 30px 0 37px;
        img {
          width: 493px;
          height: 435px;
          // &.floor2 {
          //   width: 580px;
          //   height: 510px;
          // }
        }
      }

      .floor-wrapper {
        margin-top: 30px;
        display: flex;
        border: 1px solid rgba($color: #000000, $alpha: 0.2);
        height: 120px;
        background: #f6f6f6;
        line-height: 120px;
        span {
          flex: 1;
          display: inline-block;
          text-align: center;
          font-size: 48px;
          font-weight: 400;
          color: #010101;
          cursor: pointer;
          font-family: PF-regular;

          &.active {
            background: #af844e;
            color: #fff;
          }
        }
      }
    }
    .right {
      // height: 632px;
      display: flex;
      flex-direction: column;
      .title {
        height: 96px;
        line-height: 96px;
        padding-left: 30px;
        background: #af844e;
        font-family: pf-regular;
        color: #fff;
        font-size: 48px;
        margin-bottom: 0;
      }

      .list-wrapper {
        flex: 1;
        overflow: auto;
        // border: 1px solid rgba($color: #312f2e, $alpha: 0.2);
        background: #fff;
        // &::-webkit-scrollbar-thumb {
        //   /*滚动条里面小方块*/
        //   background: #af844e;
        //   border-radius: 20px;
        // }
        // &::-webkit-scrollbar-track {
        //   /*滚动条里面轨道*/
        //   background: transparent;
        //   border-radius: 20px;
        // }
        // &::-webkit-scrollbar {
        //   width: 8px;
        // }
        .list-item {
          display: flex;
          cursor: pointer;
          flex-direction: column;
          // border-bottom: 1px solid rgba($color: #121100, $alpha: 0.2);
          margin-bottom: 31px;
          background: #fff;
          &:last-child {
            margin-bottom: 0;
          }
          .img-wrapper {
            width: 100%;
            // flex-basis: 232px;
            // flex-shrink: 0;
            // height: 130px;
          }
          img {
            width: 100%;
            height: 382px;
            object-fit: contain;
          }

          .right-content {
            height: 160px;
            background: #f6f6f6;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 31px 28px 35px 31px;
            .flex-box {
              justify-content: space-between;
            }
            p {
              &.name {
                font-size: 32px;
                font-family: pf-regular;
                font-weight: 500;
                color: #010101;
                line-height: 48px;
              }
              &.address {
                font-size: 26px;
                font-family: pf-normal;
                font-weight: 500;
                color: #ae8148;
                line-height: 40px;
              }
              &.ty {
                font-size: 26px;
                font-family: pf-regular;
                font-weight: 400;
                color: #010101;
                line-height: 40px;
                color: rgba($color: #000000, $alpha: 0.7);
              }
            }
          }
        }
      }
    }
  }
}
</style>